import { useState, useEffect } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { ColorSelect, Textarea } from 'src/components/common'
import { ErrorField, InputField } from 'src/components/formik'
import { SelectField } from 'src/components/formik/select'
import { PROBLEM_TYPES, getImages } from 'src/tools'

import BuilderTypeSwitcher from '../../../../components/builder/builder-type-switcher'

const defaultValues = {
  answer_type: null,
  problem_type: null,
  question: '',
  question_picture: '',
  answer_true: '',
  answer_false: '',
  almost: '',
  hint: '',
  hint_picture: '',
  solution: '',
  solution_picture: '',
  sort_order: 0,
  extra: null,
}

const QuestionSchema = Yup.object().shape({
  // question: Yup.string().required('Required'),
  // answer_true: Yup.string().required('Required').nullable(),
})

const QuestionForm = ({ onSubmit, error, question, practice }) => {
  const [answerTypes, setAnswerTypes] = useState([])

  const formik = useFormik({
    initialValues: defaultValues, // initialValues || {...defaultValues, ...initialValues},
    validationSchema: QuestionSchema,
    onSubmit,
  })

  useEffect(() => {
    console.log('question', question)

    // if (!question) return;

    formik.setValues({
      ...question,
      level_id: question.level_id
        ? question.level_id
        : Array.isArray(practice.levels) && practice.levels.length > 0
        ? practice.levels[0].id
        : null,
    })
  }, [question])

  useEffect(() => {
    if (!formik.values.problem_type) return

    const problem = PROBLEM_TYPES.find(
      (x) => x.value === formik.values.problem_type,
    )
    setAnswerTypes(problem?.answerTypes || [])
  }, [formik.values.problem_type])

  useEffect(() => {
    let selectedAnswerType = null

    if (Array.isArray(answerTypes) && answerTypes.length > 0) {
      if (formik.values.answer_type) {
        selectedAnswerType = answerTypes.find(
          (x) => x.value === formik.values.answer_type,
        )
      }

      if (!selectedAnswerType) {
        selectedAnswerType = answerTypes[0]
      }

      formik.setFieldValue('answer_type', selectedAnswerType.value)
    }
  }, [answerTypes])

  // const onLevelChange = ({ value }) => {
  //   formik.setFieldValue('level_id', value)
  // }

  const onProblemTypeChange = ({ value }) => {
    formik.setFieldValue('extra', '')
  }

  // const onAnswerTypeChange = ({ value }) => {
  //   formik.setFieldValue('answer_type', value)
  // }

  const handleSave = async (values) => {
    console.log('handleSave')
    console.log({ ...formik.values, ...values })

    const imgs = getImages(values.solution || '')
    const imgs2 = getImages(values.hint || '')

    const solution_images = imgs.map((x) =>
      x.replace(`${process.env.REACT_APP_S3_HOST}/`, ''),
    )
    const hint_images = imgs2.map((x) =>
      x.replace(`${process.env.REACT_APP_S3_HOST}/`, ''),
    )

    formik.setValues({
      ...formik.values,
      ...values,
      solution_images,
      hint_images,
    })
    console.log('submitForm 1')
    await formik.submitForm()
    console.log('submitForm 2')
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      {/* {formik.errors && <div className="row">
        {JSON.stringify(formik.errors)}
      </div>} */}
      <div className="row">
        <div className="col-lg-6 col-md-6 pb-30">
          <SelectField
            name="level_id"
            label="Level"
            placeholder="Level"
            options={(practice?.levels || []).map(({ id, name }) => ({
              value: id,
              label: name,
            }))}
            formik={formik}
            // onChange={onLevelChange}
          />
        </div>
        <div className="col-lg-3 col-md-6 pb-30">
          {/* {question.id}{question.problem_type} */}
          <SelectField
            name="problem_type"
            label="Problem Type"
            placeholder="Problem Type"
            options={PROBLEM_TYPES.map(({ title, value }) => ({
              value,
              label: title,
            }))}
            formik={formik}
            onChange={onProblemTypeChange}
          />
        </div>

        <div className="col-lg-3 col-md-6 pb-30">
          <SelectField
            name="answer_type"
            label="Answer Type"
            placeholder="Answer Type"
            options={answerTypes.map(({ title, value }) => ({
              value,
              label: title,
            }))}
            formik={formik}
            // onChange={onAnswerTypeChange}
          />
        </div>
      </div>

      <div className="builder">
        <BuilderTypeSwitcher
          {...question}
          key={question.id}
          question={
            formik.values.problem_type === question.problem_type
              ? question?.question
              : null
          }
          problem_type={formik.values.problem_type}
          answer_type={formik.values.answer_type}
          answer_true={formik.values.answer_true}
          extra={formik.values.extra}
          onSave={handleSave}
        />
      </div>

      {/* <div className="letter__line">
        <div className="cabinet__intro__title">
          Answer
        </div>
        <div className="row">
          <div className="cabinet__item col-12 col-md-3">
            <div className="cabinet__intro__title">
              <span className="green__text">True</span>
            </div>
            <InputField
              placeholder="25"
              formik={formik}
              name='answer_true'
            />
          </div>

          {(formik.values.answer_type === ANSWER_TYPES_ENUM.checkbox || formik.values.answer_type === ANSWER_TYPES_ENUM.radio)  &&
            <>
              <div className="cabinet__item col-12 col-md-6">
                <div className="cabinet__intro__title">
                  <span className="red__text">False</span> (Comma separated. Maximum 5)
                </div>
                <InputField
                  name='answer_false'
                  placeholder="e.g. 23, 34, 58"
                  formik={formik}
                />
              </div>

              <div className="cabinet__item col-12 col-md-3">
                <div className="cabinet__intro__title">
                  <span className="orange__text">Almost</span> (optional)
                </div>
                <InputField
                  name='almost'
                  placeholder="34"
                  formik={formik}
                />
              </div>
            </>
          }
        </div>
      </div> */}

      <div style={{ display: 'none' }}>
        <div className="letter__stroke">
          <div className="cabinet__item">
            <div className="cabinet__intro__title">
              <span className="blue__text">Hint</span> (optional)
            </div>
            <InputField
              name="hint"
              placeholder="e.g. 23, 34, 58"
              formik={formik}
            />
          </div>

          <button type="button" className="btn btn--opacity cabinet__btn">
            Upload
          </button>
        </div>

        <div className="textfiel__item cabinet__item">
          <div className="cabinet__intro__title">Solution</div>
          <Textarea
            name="solution"
            onChange={formik.handleChange}
            value={formik.values.solution}
          />
          <ErrorField formik={formik} name="solution" />
        </div>
      </div>
    </form>
  )
}

export default QuestionForm
